import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

const REMITENTE_CORREO = 'apps@divemotor.com.pe';
export default function assignProforma(fdvID, proformaList) {

 const obj = {
   numFichaVtaVeh: fdvID,
   nurFichaVtaVeh: 0,
   coUsuarioInactiva: '',
   codColorVeh: '',
   codColorVehAnt: '',
   codContacClie: '',
   codContacProp: '',
   codContacUsu: '',
   codDocFact: '',
   codPersoDir: '',
   codPersoProp: '',
   codPersoUsu: '',
   desColorVeh: '',
   fecEntregaAprox: '',
   fecInactiva: '',
   indInactivo: 'N',
   indPrenda: 0,
   indSolFact: '',
   nomCarrocero: '',
   nomLugarEntrega: '',
   numRegDir: 0,
   numRegProp: 0,
   numRegUsu: 0,
   numSoliCredVeh: '',
   tipoCarrocero: '',
   remitente:REMITENTE_CORREO
 }


  const data =  proformaList.map(entry => {return Object.assign({},entry,obj)});

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };


  return customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/proformas`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/assignProforma.js